export const loginUser = async (userParam, passwordParam) => {

    try {
        const response = await fetch('https://dev-backend.fcf.services/users/login-intranet', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ user: userParam, pass: passwordParam})
        });

        if(!response.ok){
            throw new Error('Failed to login');
        }

        const data = await response.json();
        if(data.auth){
            return data.data;
        } else {
            console.log('Failed to login');
            return null;
        }
        
    } catch (error){
        console.log('Failed to fetch', error);
        return null;
    };
    
};